import React from 'react';
import Ico from './Ico';

const ICO_TAG = 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01';

const TIER_STYLES = {
  trial:      { background: '#F4F3FF', color: '#5925DC', border: '1px solid #D9D6FE' },
  enterprise: { background: '#EFF8FF', color: '#175CD3', border: '1px solid #B2DDFF' },
  premium:    { background: '#FFF6ED', color: '#C4320A', border: '1px solid #F9DBAF' },
  dev:        { background: '#F2F4F7', color: '#344054', border: '1px solid #D0D5DD' },
};

const BASE = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '1px 7px',
  borderRadius: '99px',
  fontSize: '10.5px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export default function TierPill({ tier }) {
  const key = (tier || '').toLowerCase();
  const s = TIER_STYLES[key] || { background: '#F2F4F7', color: '#344054', border: '1px solid #D0D5DD' };
  const label = tier ? tier.charAt(0).toUpperCase() + tier.slice(1) : '–';
  return (
    <span style={{ ...BASE, ...s }}>
      <Ico d={ICO_TAG} size={10} />
      {label}
    </span>
  );
}
